export const tableHead = [
    {
        title: "Ride Creator",
        width: "14%",
    },
    {
        title: "Ride Name",
        sortKey: "name",
        width: "18%",
    },
    {
        title: "Creation Date",
        sortKey: "createdAt",
        width: "9%",
    },
    {
        title: "Start Date",
        sortKey: "startDateTime",
        width: "9%",
    },
    {
        title: "From → To",
        width: "14%",
    },
    {
        title: "Count",
        sortKey: "riderCount",
        width: "6%",
    },
    {
        title: "Limit",
        width: "6%",
    },
    {
        title: "Price",
        width: "8%",
    },
    {
        title: "Status",
        width: "8%",
    },
    {
        title: "Public",
        width: "5%",
    },
    {
        title: "Action",
        sortKey: "",
        width: "3%",
        textAlign: "center",
    },
];

export const userList = [
    {
        rideCreator: "Lia Castro",
        rideCreatorOrg: "Lia_Castro_Rider",
        rideName: "Neemrana Ride",
        startDate: "27 Jul’ 20",
        from: "New Delhi",
        to: "Neemrana",
        count: "12",
        limit: "200",
        price: "free",
        status: "1",
    },
    {
        rideCreator: "Lia Castro",
        rideCreatorOrg: "Lia_Castro_Rider",
        rideName: "Neemrana Ride",
        startDate: "27 Jul’ 20",
        from: "New Delhi",
        to: "Neemrana",
        count: "12",
        limit: "200",
        price: "free",
        status: "2",
    },
    {
        rideCreator: "Lia Castro",
        rideCreatorOrg: "Lia_Castro_Rider",
        rideName: "Neemrana Ride",
        startDate: "27 Jul’ 20",
        from: "New Delhi",
        to: "Neemrana",
        count: "12",
        limit: "200",
        price: "free",
        status: "3",
    },
];
